export default "__VITE_ASSET__Dh7Q8TAa__"